import { render, staticRenderFns } from "./SaleForm.vue?vue&type=template&id=f3865a70&"
var script = {}
import style0 from "./SaleForm.vue?vue&type=style&index=0&lang=scss&scopped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports